export default "__VITE_PUBLIC_ASSET__c47d3135__"